import React from 'react';
import Image from '@ff/ui/Image';
import CustomVideo from './CustomVideo';

interface Props {
  /** Image or video source URL */
  src?: string;
  imageAlt?: string;
}

export default function Asset(props: Props) {
  const { src, imageAlt } = props;

  if (!src) return null;

  const isVideo = /(mp4|mov)$/.test(src);

  if (isVideo) {
    return (
      <CustomVideo src={src} />
    )
  }

  return (
    <Image lazy src={src} alt={imageAlt || "Social media image"} />
  );
}
